<script setup>
import {computed, ref} from 'vue'
import {useFormStore} from '@/stores/form'
import {useUniqueValue} from '@/composables/useUniqueValue'
import vFormValidation from '@/vue/directives/formValidation'
import FormControlPlainText from "@/common/form-control/FormControlPlainText.vue"

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
    value: String // Added to support the watch target inside the composable
})

// Pinia Store
const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)

// Accessing the DOM element for validation side-effects
const fieldInputRef = ref(null)

// Initialize Vue 3 style composable logic
useUniqueValue(props, fieldInputRef)

// Computed properties
const formSmall = computed(() => {
    return formStore.value?.formSmall
})

// Emulating the created hook logic via Pinia action
formStore.value?.setDefaultValue({
    name: props.field.name,
    value: ''
})
</script>

<template>
    <FormControlPlainText v-if="field.readonly" :value="currentData[field.name]" :form-id="formId"/>
    <input v-else :id="field.id" ref="fieldInputRef" v-model="currentData[field.name]" v-select="field.autofocus"
           v-form-validation
           :disabled="field.disabled" :max="field.max" :min="field.min" :name="field.name" :required="field.required"
           :step="field.step" autocomplete="off" class="form-control"
           :class="{'is-invalid': field.error, 'form-control-sm': formSmall}" type="week">
</template>